import { PageMeta } from '@/@vxapp/@Enums/PageMeta'

export default [
  { heading: 'Business Operations' },
  {
    page: PageMeta.Projects.list,
    title: 'Projects',
    icon: { icon: PageMeta.Projects.icon },
    to: PageMeta.Projects.list.name,
    meta: PageMeta.Projects.list.meta,
  },
  {
    page: PageMeta.Assets.list,
    title: 'Assets',
    icon: { icon: PageMeta.Assets.list.icon },
    to: PageMeta.Assets.list.name,
  },
]
